import React from 'react';

import { LoginContainer } from '../../containers';

export const Login: React.FC = () => <LoginContainer />;
